import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import { Button } from "aible";

import styles from "components/FieldFeatures/style.module.css";

import MarketplaceTitle from "containers/CreateWizard/Marketplace/MarketplaceTitle";
import MarketplaceDescription from "containers/CreateWizard/Marketplace/MarketplaceDescription";

import MarketplaceSelect from "containers/Marketplace/MarketplaceSelect";

import { getAllowGlobalPublish } from "containers/Marketplace/reducer";

import * as marketplaceReducer from "containers/Marketplace/reducer";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";

class MarketplaceContainer extends React.Component {
  render() {
    const {
      isDemo,
      publish,
      onHide,
      allowGlobalPublish,
      internalMarketplaceId,
      selectedMarketplaceId,
      marketplaces,
      internalMarketplaces,
      show
    } = this.props;
    return (
      <Dialog open={show} onOpenChange={() => onHide()}>
        <DialogContent size="xl">
          <DialogHeader>
            <DialogTitle>{"Publish Blueprint"}</DialogTitle>
          </DialogHeader>

          <div>Publish this blueprint to your internal marketplace.</div>
          {isDemo ? (
            <div>
              <MarketplaceTitle {...this.props} />
              <MarketplaceDescription {...this.props} />
            </div>
          ) : (
            <div>
              <MarketplaceTitle {...this.props} />
              <MarketplaceDescription {...this.props} />
            </div>
          )}
          {Boolean(allowGlobalPublish || (internalMarketplaces && internalMarketplaces.length > 1)) && (
            <div>
              <h5>Publish To:</h5>
              <MarketplaceSelect
                {...this.props}
                marketplaces={allowGlobalPublish ? marketplaces : internalMarketplaces}
              />
            </div>
          )}

          <DialogFooter>
            <Button type="secondary" onClick={() => onHide()}>
              {"Close"}
            </Button>
            <Button
              type="primary"
              onClick={() => {
                onHide();
                if (allowGlobalPublish || (internalMarketplaces && internalMarketplaces.length > 1)) {
                  publish(selectedMarketplaceId);
                } else {
                  publish(internalMarketplaceId);
                }
              }}
            >
              {"Publish"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  publish: (marketplaceId) => dispatch(marketplaceReducer.publishBlueprint(ownProps.blueprintId, marketplaceId))
});

const mapStateToProps = (state) => ({
  allowGlobalPublish: getAllowGlobalPublish(),
  marketplaces: marketplaceReducer.getMarketplaceArr(state),
  internalMarketplaces: marketplaceReducer.getInternalMarketplaces(state),
  internalMarketplaceId: marketplaceReducer.getInternalMarketplace(state),
  selectedMarketplaceId: marketplaceReducer.getSelected(state)
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(MarketplaceContainer);
